export default {
  language: "Idioma",
  spanish: "Español",
  english: "English",
  back: "Volver",
  backHome: "Volver al Inicio",
  backToHome: "Volver al inicio",
  save: "Guardar",
  saving: "Guardando…",
  cancel: "Cancelar",
  delete: "Eliminar",
  edit: "Editar",
  search: "Buscar",
  loading: "Cargando...",
  error: "Error",
  success: "Éxito",
  understood: "Entendido",
  close: "Cerrar",
  settings: "Settings",
  profile: "Perfil",
  myAccount: "Mi cuenta",
  admin: "Admin",
  logout: "LogOut",
  yes: "Sí",
  no: "No",
  confirm: "Confirmar",
  required: "Obligatorio",
  optional: "Opcional",
  noResults: "No se encontraron resultados",
  imageUnavailable: "Imagen no disponible",
  allRightsReserved: "Todos los derechos reservados.",
  restrictedAccess: "Acceso Restringido",
  importantInfo: "Información Importante",
  selectDate: "Seleccionar Fecha",
  private: "Particular",
  insurance: "Obra Social",
  demo: "Demo - Acceso Rápido",
};
